import { productVariables } from 'common/config/variables';
import { getScalablePixel } from 'common/utils';

export const SAFE_AREA_VIEW_PADDING = getScalablePixel(98);
export const VERTICAL_SAFE_AREA_VIEW_PADDING = productVariables.MENU_SIZE + SAFE_AREA_VIEW_PADDING;
export const DETAILED_INFO_SAFE_AREA_PADDING = getScalablePixel(102);

export const LOADING_WAITS_FOR_PLAYER = false;
